import instance from '../scorpiusInstance';
import {
  UPDATE_PERMISSION_ROLES_START,
  UPDATE_PERMISSION_ROLES_SUCCESS,
  UPDATE_PERMISSION_ROLES_ERROR,
} from '../types';

export const updatePermissionRolesStart = (orgId, appName) => ({
  type: UPDATE_PERMISSION_ROLES_START,
  orgId,
  appName,
});

export const updatePermissionRolesSuccess = (orgId, appName, permission) => ({
  type: UPDATE_PERMISSION_ROLES_SUCCESS,
  orgId,
  appName,
  permission,
});

export const updatePermissionRolesError = (orgId, appName, error) => ({
  type: UPDATE_PERMISSION_ROLES_ERROR,
  orgId,
  appName,
  error,
});

/**
 * Updates which roles have a permission assigned to them.
 * @param {String} orgId
 * @param {String} appName
 * @param {Object} payload
 * @param {String} permission - Required
 * @param {String} payload.role_ids - Required
 */
export const updatePermissionRoles =
  (orgId, appName, payload, permission) => async dispatch => {
    dispatch(updatePermissionRolesStart(orgId, appName));
    try {
      const response = await instance.patch(
        `/organizations/${orgId}/${appName}/permissions/${permission}/roles`,
        payload,
        { headers: { retry: true } },
      );

      dispatch(updatePermissionRolesSuccess(orgId, appName, response.data));
    } catch (error) {
      throw dispatch(updatePermissionRolesError(orgId, appName, error));
    }
  };

export default updatePermissionRoles;
